import SVGIconBase from './SVGIconBase';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ServiceIcon = props => /*#__PURE__*/_jsxs(SVGIconBase, Object.assign({
  "data-test-id": "vertical-nav-icon__content"
}, props, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M5.03,20.01c.55,0,1-.45,1-1,0-5.27,4.5-9.56,10.03-9.56s10.03,4.29,10.03,9.56c0,.55.45,1,1,1s1-.45,1-1c0-6.37-5.4-11.56-12.03-11.56s-12.03,5.18-12.03,11.56c0,.55.45,1,1,1Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M14.11,5.99h3.89c.55,0,1-.45,1-1s-.45-1-1-1h-3.89c-.55,0-1,.45-1,1s.45,1,1,1Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M29.96,28.69l-2.08-6.11c-.14-.41-.52-.68-.95-.68H5.05c-.43,0-.81.27-.95.68l-2.09,6.11c-.1.31-.05.64.13.91s.49.42.81.42h26.06c.32,0,.62-.16.81-.42.19-.26.24-.6.13-.9ZM4.36,28.01l1.41-4.11h20.46l1.4,4.11H4.36Z"
  })]
}));
export default ServiceIcon;